/**
 * @generated SignedSource<<a30aca41573448b751e4714b2da09634>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest, Mutation } from 'relay-runtime';
export type PERIODICITY = "DAILY" | "WEEKLY" | "MONTHLY" | "%future added value";
export type PERIOD_BUDGET_TYPE = "FIXED_PRICE" | "FIXED_HOURS" | "TIME_AND_MATERIALS" | "%future added value";
export type CreateRetainerPeriodInput = {
  projectId?: string | null;
  name?: string | null;
  startYear?: number | null;
  startMonth?: number | null;
  startDay?: number | null;
  endYear?: number | null;
  endMonth?: number | null;
  endDay?: number | null;
  preCreateAmount?: number | null;
  csrfToken?: string | null;
  socketClientId?: string | null;
  clientMutationId?: string | null;
};
export type createRetainerPeriodMutation$variables = {
  input: CreateRetainerPeriodInput;
};
export type createRetainerPeriodMutation$data = {
  readonly createRetainerPeriod: {
    readonly retainerPeriod: {
      readonly node: {
        readonly id: string;
        readonly name: string | null;
        readonly startYear: number | null;
        readonly startMonth: number | null;
        readonly startDay: number | null;
        readonly endYear: number | null;
        readonly endMonth: number | null;
        readonly endDay: number | null;
        readonly available: number | null;
        readonly periodLength: number | null;
        readonly periodPeriodicity: PERIODICITY | null;
        readonly periodPriceAmount: number | null;
        readonly periodHoursAmount: number | null;
        readonly periodBudgetType: PERIOD_BUDGET_TYPE | null;
        readonly periodSettingIgnoreForBilling: boolean | null;
        readonly periodSettingSubtractValue: boolean | null;
        readonly periodSettingRollValue: boolean | null;
        readonly periodSettingAddExpenses: boolean | null;
        readonly periodDifferencePriceAmount: number | null;
        readonly periodDifferenceHoursAmount: number | null;
        readonly sharedPeriodDifferenceHoursAmount: number | null;
        readonly sharedPeriodDifferencePriceAmount: number | null;
        readonly ignoredRolloverHours: number | null;
        readonly ignoredRolloverPrice: number | null;
        readonly periodLocked: boolean | null;
        readonly periodLockedTime: string | null;
        readonly periodDifferenceSplit: boolean | null;
      } | null;
    } | null;
    readonly errors: ReadonlyArray<string | null> | null;
  } | null;
};
export type createRetainerPeriodMutation = {
  variables: createRetainerPeriodMutation$variables;
  response: createRetainerPeriodMutation$data;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "input"
  }
],
v1 = [
  {
    "alias": null,
    "args": [
      {
        "kind": "Variable",
        "name": "input",
        "variableName": "input"
      }
    ],
    "concreteType": "CreateRetainerPeriodPayload",
    "kind": "LinkedField",
    "name": "createRetainerPeriod",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "RetainerPeriodTypeEdge",
        "kind": "LinkedField",
        "name": "retainerPeriod",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": "RetainerPeriodType",
            "kind": "LinkedField",
            "name": "node",
            "plural": false,
            "selections": [
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "id",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "name",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "startYear",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "startMonth",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "startDay",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "endYear",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "endMonth",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "endDay",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "available",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "periodLength",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "periodPeriodicity",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "periodPriceAmount",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "periodHoursAmount",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "periodBudgetType",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "periodSettingIgnoreForBilling",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "periodSettingSubtractValue",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "periodSettingRollValue",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "periodSettingAddExpenses",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "periodDifferencePriceAmount",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "periodDifferenceHoursAmount",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "sharedPeriodDifferenceHoursAmount",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "sharedPeriodDifferencePriceAmount",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "ignoredRolloverHours",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "ignoredRolloverPrice",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "periodLocked",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "periodLockedTime",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "periodDifferenceSplit",
                "storageKey": null
              }
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "errors",
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "createRetainerPeriodMutation",
    "selections": (v1/*: any*/),
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "createRetainerPeriodMutation",
    "selections": (v1/*: any*/)
  },
  "params": {
    "cacheID": "02c723022d794a4c6aad242e249d2d11",
    "id": null,
    "metadata": {},
    "name": "createRetainerPeriodMutation",
    "operationKind": "mutation",
    "text": "mutation createRetainerPeriodMutation(\n  $input: CreateRetainerPeriodInput!\n) {\n  createRetainerPeriod(input: $input) {\n    retainerPeriod {\n      node {\n        id\n        name\n        startYear\n        startMonth\n        startDay\n        endYear\n        endMonth\n        endDay\n        available\n        periodLength\n        periodPeriodicity\n        periodPriceAmount\n        periodHoursAmount\n        periodBudgetType\n        periodSettingIgnoreForBilling\n        periodSettingSubtractValue\n        periodSettingRollValue\n        periodSettingAddExpenses\n        periodDifferencePriceAmount\n        periodDifferenceHoursAmount\n        sharedPeriodDifferenceHoursAmount\n        sharedPeriodDifferencePriceAmount\n        ignoredRolloverHours\n        ignoredRolloverPrice\n        periodLocked\n        periodLockedTime\n        periodDifferenceSplit\n      }\n    }\n    errors\n  }\n}\n"
  }
};
})();

(node as any).hash = "f3121c936e6a1f930df8b5d037af7c1b";

export default node;
